<template>
<article class="article">
	<div v-if="!isAuditing">
		<!-- <p class="mt20 fwbd tc">汇庄金服隐私权政策 </p>
            <p class="fwbd mt20">概述和声明 </p>
            <p class="mt20">深圳市汇庄金融服务有限公司及旗下公司（以下称“汇庄金服”或称“我们”）尊重并保护用户隐私，我们将按照本隐私权政策（以下简称“本政策”）收集、使用及共享您的个人信息。本政策包含了我们<span class="fwbd">收集、存储、保护、使用和共享您的个人信息</span>的条款，我们建议您完整地阅读本政策，以帮助您了解维护自己隐私权的方式。当您同意汇庄金服的服务协议时，或您访问汇庄金服的网站（如深圳市汇庄金融服务有限公司网站（http://www.zhonglianbiz.com/）及其相关网站）、移动设备客户端点点、微信公众号时，或您使用我们提供的任一服务时，代表您已在知情和同意的情况下，自愿向汇庄金服提供您的个人用户信息。 </p>
            <p>本政策所称<span class="fwbd">“汇庄金服”</span>，包括： 1、深圳市汇庄金融服务有限公司； 2、深圳市汇庄金融服务有限公司直接或间接控股的公司； 3、深圳市汇庄金融服务有限公司参股或形成经营、协作联系的关联单位。 </p>
            <p>以上包括现有或将来设立的符合以上条件的公司主体。我们将按照本政策来收集、保护、使用、共享您的个人信息，如国家法律法规或监管规定对汇庄金服另行规定或您与汇庄金服另行约定的条款与本政策不一致的，以另行规定、约定的为准。 </p>
            <p>我们收集、使用您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的（包括开发新产品或完善已有产品功能；为您和其他用户提供更为优质的服务等）。若您向我们提供了本政策中列明的信息，您可使用更多汇庄金服的服务，和（或）享受更便捷的客户服务，和（或）避免我们无法及时与您取得联系而产生对您不利的影响等。 </p>
            <p class="fwbd mt20">一． 收集个人信息的范围：</p>
            <p class="mt20">当您访问汇庄金服的网站、移动设备客户端及/或微信公众号时，或您使用汇庄金服平台上提供的服务时，您会向我们主动提供一些信息，我们也会收集您的一些信息。</p>
            <p>我们收集信息的范围主要包括：</p>
            <p>1、为了遵守法律法规的要求以及向您提供更个性化、更便捷的服务，我们需要识别您的身份。例如在您注册点点APP账户或购买点点APP平台上提供的产品或者服务时，您可能要向我们提供一些个人信息，包括但不限于您的姓名、身份证明、地址、工作单位、电话号码和电子邮件地址、生物特征等信息及相关附加信息（如您所在的省份和城市、邮政编码等）。</p>
            <p>2、如您使用的汇庄金服的服务与产品需与您的银行账户或其他支付工具的账户关联方能实现时，您需要向我们提供您的银行账户信息或其他支付工具的账户信息。</p>
            <p>3、我们同时可能会从汇庄金服旗下公司和商业合作伙伴获得信息以补充我们自己收集的信息。 </p>
            <p>4、为了保护您的账户安全，当您访问汇庄金服的网站或移动设备客户端时，或使用汇庄金服提供的服务时，我们可能会记录您操作的相关信息，包括但不限于您的网络信息、设备标识符、硬件型号、操作系统版本、您的位置以及与汇庄金服的服务相关的日志信息，这些信息可帮助我们更好地识别您的身份。</p>
            <p>5、为使您获得更轻松的访问体验，您访问汇庄金服的网站或使用汇庄金服平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。我们网站上还可能包含一些电子图象（称为“单像素GIF文件”或“网络Beacon”），使用网络Beacon可以帮助网站计算浏览网页的用户或访问某些Cookie，我们会通过网络Beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。</p>
            <p>除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与汇庄金服及旗下公司互动时我们收集的相关信息、与您曾使用的移动应用（APP）和其他软件相关的信息。与此同时，为提高您使用汇庄金服提供的服务的安全性，更准确地预防钓鱼
            网站、短信欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息以及通过识别您短信中的欺诈内容等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL、IP地址等。</p>
            <p class="fwbd mt20">二、使用个人信息的范围：</p>
            <p>因收集您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的，为了实现这一目的，我们可能会把您的信息用于下列用途：</p>
            <p>1、向您提供或推荐汇庄金服的各项服务及客户服务，并维护、改进这些服务。</p>
            <p>2、比较信息的准确性，并与第三方进行验证。例如，将您向我们提交的身份信息与身份验证的服务机构进行验证。</p>
            <p>3、为使您知晓自己使用汇庄金服的各项服务的情况或了解汇庄金服的服务，向您发送服务状态的通知、营销活动及其他商业性信息。</p>
            <p>4、对汇庄金服用户的身份数据、交易信息等进行综合统计、分析或加工等处理，可能会出于销售、奖励或为了向您推荐更合适的产品或者服务而使用、共享或披露这些经过处理的信息。例如，我们可能会统计某个时间段关注某个产品或者服务的新客户，向这些新用户提供专享优惠活动。</p>
            <p>5、预防或禁止非法的活动。</p>
            <p>6、经您许可的其他用途。</p>
            <p>7、与您保持联系，包括向您寄发有关您在我们公司任何账户或本隐私声明日后变动的通讯。</p>
            <p>8、供汇庄金服、金融服务业或我们的相关监管机构的统计或研究之用。</p>
            <p>9、供我们作资料匹配，内部业务及管理之用。</p>
            <p>10、协助执行法例、警方或其他政府或监管机构调查，以及遵守适用法律及规例所施行的规定，或其他向政府或监管机构承诺之义务。</p>
            <p>11、在收集之时所通知的其他用途。</p>
            <p>12、及与上述任何项目直接间接有关的其他用途。</p>
            <p class="fwbd mt20">三、共享个人信息的范围</p>
            <p>我们对您的信息承担保密义务，但我们有权在下列情况下将您的信息与第三方共享：</p>
            <p>1、获得您的同意或授权。</p>
            <p>2、为了向您提供或推荐服务、产品，或为了向您提供更完善的服务，或某些情况下，只有共享您的信息，才能提供您需要的服务和（或）产品，或某些服务和（或）产品由我们的合作伙伴提供或由我们与合作伙伴、供应商共同提供，我们会在汇庄金服内部以及与包括汇庄金服旗下公司在内的第三方共享您的相关信息。</p>
            <p>3、为了判断您的账户或交易是否安全。</p>
            <p>4、我们与第三方进行联合推广活动，我们可能与其共享活动过程中产生的、为完成活动所必要的个人信息，如参加活动的用户数、中奖名单、中奖人联系方式等，以便第三方能及时向您发放奖品。</p>
            <p>5、为维护汇庄金服用户的合法权益。</p>
            <p>6、根据法律规定及合理商业习惯，在我们计划与其他公司合并或被其收购或进行其他资本市场活动（包括但不限于IPO，债券发行）时，以及其他情形下我们需要接受来自其他主体的尽职调查时，我们会把您的信息提供给必要的主体，但我们会通过和这些主体签署保密协议等方式要求其对您的个人信息采取合理的保密措施。</p>
            <p>7、如您授权第三方向我们查询、采集您在汇庄金服公司的账户或保单相关信息，我们有权在法律法规允许和您的授权许可范围内向第三方分享您账户或其他相关信息。</p>
            <p>8、为了维护和改善我们的服务。</p>
            <p>9、根据法律法规的规定或有权机关的要求。</p>
            <p>除上述用途外，汇庄金服不会将您的个人信息用于任何未经您同意的用途，不会将所接受的任何个人信息泄露、篡改、毁损、出售或者提供给任何第三方。</p>
            <p>汇庄金服会遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。</p>
            <p>您可以提交书面请求以查阅您的个人信息，或要求对错误的信息进行更正、修改或删除。如果您的个人信息有任何变动，请通知我们以便我们保持信息更新并提供更好的服务。此外，您可以通过书面方式要求汇庄金服从数据库中取消您所登记的任何服务并停止使用您的个人信息。</p>
            <p class="fwbd mt20">对第三方责任的声明</p>
            <p>请您注意，您的交易相对方、您访问的第三方网站经营者、您使用的第三方服务提供者和由汇庄金服处接受您的个人信息的第三方可能有自己的隐私权保护政策；当您查看第三方创建的网页或使用第三方开发的应用程序时，可能会发现该网页或应用程序放置的Cookie或像素标签。同样，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或标签不受我们的控制，而且它们的使用不受本政策的约束。</p>
            <p>我们会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施，亦不对这些主体的行为及后果承担任何责任。如果您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。</p>
            <p>未成年人隐私权特别约定</p>
            <p>我们重视未成年人的个人信息保护，如您为未成年人，建议您请您的监护人仔细阅读本政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。</p>
            <p>任何与您个人信息有关的请求或投诉，以及要求取消您所选取的汇庄金服的任何服务，请发送电子邮件至：kefu@zhonglianbiz.com或者致函以下地址：深圳市南山区滨海大道3012号三诺智慧大厦25F，邮编：518000。</p>
            <p>汇庄金服"隐私权政策"体现了我们将按照国家关于个人信息保护有关法律法规保护和管理您个人信息的承诺，我们会根据不时修订的相关法规要求更新本"隐私权政策"。我们的"隐私权政策"公布于汇庄金服官方网站：http://www.zhonglianbiz.com/，方便您随时查阅。</p> -->

		<!-- <p class="mt20 fwbd tc">点点隐私政策 </p>
		<p class="fwbd mt20">概述和声明</p>
		<p class="mt20">点点尊重并保护用户隐私，我们将按照本隐私政策（以下简称“本政策”）<span class="fwbd">收集、使用、保存及共享您的个人信息</span>。本政策包含了我们收集、保护、使用和共享您的个人信息的条款，我们建议您完整地阅读本政策，以帮助您了解维护自己隐私权的方式。当您同意点点的服务协议时，或您访问点点的网站（http://www.zhonglinabiz.com）及其相关网站、移动设备客户端点点、微信公众号时，或您使用我们提供的任一服务时，代表您已在知情和同意的情况下，自愿向点点提供您的个人用户信息。
		</p>
		<p>我们将按照本政策来收集、保护、使用、共享您的个人信息，如国家法律法规或监管规定有另行规定或您与点点有另行约定的，以另行规定或约定为准。我们收集、使用您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的（包括开发新产品或完善已有产品功能；为您和其他用户提供更为优质的服务等）。若您向我们提供了本政策中列明的信息，您可使用更多点点的服务，和（或）享受更便捷的客户服务，和（或）避免我们无法及时与您取得联系而产生对您不利的影响等。</p>
		<p class="fwbd mt20">一．我们收集您个人信息的情形</p>
		<p>当您访问点点的网站、移动设备客户端及/或微信公众号时，或您使用点点平台上提供的服务时，您会向我们主动提供一些信息，同时您也须授权我们收集和使用您的一些个人信息。</p>
		<p>我们收集信息的范围主要包括：</p>
		<p>1、为了遵守法律法规的要求以及向您提供更个性化、更便捷的服务，我们需要识别您的身份。例如在您注册点点账户或购买点点平台上提供的产品或者服务时，您可能要向我们提供一些个人信息，包括但不限于您的姓名、身份证明、地址、工作单位、电话号码和电子邮件地址、生物特征、个人财产信息等信息及相关附加信息（如您所在的省份和城市、邮政编码等）。</p>
		<p>2、如您使用的点点的服务与产品需与您的银行账户或其他支付工具的账户关联方能实现时，您需要向我们提供您的银行账户信息或其他支付工具的账户信息。</p>
		<p>3、我们同时可能会从点点旗下公司和商业合作伙伴获得信息以补充我们自己收集的信息。</p>
		<p>4、为了保护您的账户安全，当您访问点点的网站或移动设备客户端时，或使用点点提供的服务时，我们可能会记录您操作的相关信息，包括但不限于您的网络信息、设备标识符、硬件型号、操作系统版本、您的位置以及与点点的服务相关的日志信息，这些信息可帮助我们更好地识别您的身份。</p>
		<p>5、为使您获得更轻松的访问体验，您访问点点的网站或使用点点平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash
			Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。我们网站上还可能包含一些电子图象（称为“单像素GIF文件”或“网络Beacon”），使用网络Beacon可以帮助网站计算浏览网页的用户或访问某些Cookie，我们会通过网络Beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。</p>
		<p>6、除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与点点及旗下公司互动时我们收集的相关信息、与您曾使用的移动应用（APP）和其他软件相关的信息。与此同时，为提高您使用点点提供的服务的安全性，更准确地预防钓鱼网站、短信欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息以及通过识别您短信中的欺诈内容等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL、IP地址等。</p>
		<p>7、我们从第三方获得您个人信息的情形 我们可能从第三方获取您授权共享的账户信息，并在您同意本隐私政策后将您的第三方账户与您的点点账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</p>
		<p class="fwbd mt20">二、我们使用您个人信息的情形：</p>
		<p>因收集您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的，为了实现这一目的，我们可能会把您的信息用于下列用途：</p>
		<p>1、向您提供或推荐点点的各项服务及客户服务，并维护、改进这些服务。</p>
		<p>2、比较信息的准确性，并与有合作关系的第三方进行验证。例如，将您向我们提交的身份信息与身份验证的服务机构进行验证。</p>
		<p>3、为使您知晓自己使用点点的各项服务的情况或了解点点的服务，向您发送服务状态的通知、营销活动及其他商业性信息。</p>
		<p>4、对点点用户的身份数据、交易信息等进行综合统计、分析或加工等处理，可能会出于销售、奖励或为了向您推荐更合适的产品或者服务而使用、共享或披露这些经过处理的信息。例如，我们可能会统计某个时间段关注某个产品或者服务的新客户，向这些新用户提供专享优惠活动。</p>
		<p>5、预防或禁止非法的活动。</p>
		<p>6、保障交易安全所必须的功能。</p>
		<p>7、经您许可的其他用途。</p>
		<p>8、与您保持联系，包括向您寄发有关您在我们公司任何账户或本隐私声明日后变动的通讯。</p>
		<p>9、供点点、金融服务业或我们的相关监管机构的统计或研究之用。</p>
		<p>10、供我们作资料匹配，内部业务及管理之用。</p>
		<p>11、协助执行法例、警方或其他政府或监管机构调查，以及遵守适用法律及规例所施行的规定，或其他向政府或监管机构承诺之义务。</p>
		<p>12、在收集之时所通知的其他用途。</p>
		<p>13、及与上述任何项目直接间接有关的其他用途。</p>
		<p class="fwbd mt20">三、我们共享您个人信息的情形</p>
		<p>我们对您的信息承担保密义务，但我们有权在下列情况下将您的信息与第三方共享：</p>
		<p>1、获得您的同意或授权。</p>
		<p>2、为了向您提供或推荐服务、产品，或为了向您提供更完善的服务，或某些情况下，只有共享您的信息，才能提供您需要的服务和（或）产品，或某些服务和（或）产品由我们的合作伙伴提供或由我们与合作伙伴、供应商共同提供，我们会在点点内部以及与包括点点旗下公司在内的第三方共享您的相关信息。</p>
		<p>3、为了判断您的账户或交易是否安全。</p>
		<p>4、我们与第三方进行联合推广活动，我们可能与其共享活动过程中产生的、为完成活动所必要的个人信息，如参加活动的用户数、中奖名单、中奖人联系方式等，以便第三方能及时向您发放奖品。</p>
		<p>5、为维护点点用户的合法权益。</p>
		<p>6、根据法律规定及合理商业习惯，在我们计划与其他公司合并或被其收购或进行其他资本市场活动（包括但不限于IPO，债券发行）时，以及其他情形下我们需要接受来自其他主体的尽职调查时，我们会把您的信息提供给必要的主体，但我们会通过和这些主体签署保密协议等方式要求其对您的个人信息采取合理的保密措施。</p>
		<p>7、如您授权第三方向我们查询、采集您在点点公司的账户或保单相关信息，我们有权在法律法规允许和您的授权许可范围内向第三方分享您账户或其他相关信息。</p>
		<p>8、为了维护和改善我们的服务。</p>
		<p>9、根据法律法规的规定或有权机关的要求。</p>
		<p>除上述用途外，点点不会将您的个人信息用于任何未经您同意的用途，不会将所接受的任何个人信息泄露、篡改、毁损、出售或者提供给任何第三方。点点会遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。</p>
		<p>您可以提交书面请求以查阅您的个人信息，或要求对错误的信息进行更正、修改或删除。如果您的个人信息有任何变动，请通知我们以便我们保持信息更新并提供更好的服务。此外，您可以通过书面方式要求点点从数据库中取消您所登记的任何服务并停止使用您的个人信息。</p>
		<p>四、您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</p>
		<p class="fwbd mt20">四、您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</p>
		<p>1、与国家安全、国防安全有关的；</p>
		<p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
		<p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
		<p>4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
		<p>5、所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
		<p>6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
		<p>7、根据您的要求签订合同所必需的；</p>
		<p>8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>
		<p>9、为合法的新闻报道所必需的；</p>
		<p>10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
		<p>11、法律法规规定的其他情形。</p>
		<p class="fwbd mt20">五、对第三方责任的声明</p>
		<p>请您注意，您的交易相对方、您访问的第三方网站经营者、您使用的第三方服务提供者和由点点处接受您的个人信息的第三方可能有自己的隐私保护政策；当您查看第三方创建的网页或使用第三方开发的应用程序时，可能会发现该网页或应用程序放置的Cookie或像素标签。同样，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或标签不受我们的控制，而且它们的使用不受本政策的约束。</p>
		<p>我们会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施，亦不对这些主体的行为及后果承担任何责任。如果您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。</p>
		<p class="fwbd mt20">六、未成年人隐私权特别约定</p>
		<p>我们重视未成年人的个人信息保护，如您为未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。点点根据国家相关法律法规的规定保护未成年人的个人信息。</p>
		<p class="fwbd mt20">七、通知和修订 </p>
		<p>点点"隐私政策"体现了我们将按照国家关于个人信息保护有关法律法规保护和管理您个人信息的承诺，为给您提供更好的服务，我们会根据不时修订的相关法规要求更新本"隐私政策"。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。</p>
		<p>我们的"隐私政策"公布于点点官方网站：www.zhonglianbiz.com以及移动端，方便您随时查阅，及时了解点点最新的隐私政策。</p>
		<p class="fwbd mt20">八、如何联系我们</p>
		<p>如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，任何与您个人信息有关的请求或投诉，请通过客服电话与我们联系：400-999-9595转6转7（9:00-21:00) </p> -->


		<h3 class="mt20 fwbd tc"><b>点点隐私政策</b></h3>

		<p><b>概述和声明</b></p>

		<p>本政策适用于您访问点点网站（https://www.diandian.com.cn）及移动互联网应用程序APP（名称可能为点点plus或点点加其他后缀名称）、小程序、微信公众号时，点点为您提供的各项服务和产品，如网上购物、消费金融咨询服务、生活娱乐服务、第三方服务等各项产品或服务。</p>

		<p>您知晓点点（亦可简称为“我们”）将因经营需要可能会不时的调整上述服务或者产品的具体营销推广名称，但是不因此影响点点提供的服务和产品类型的认定。</p>

		<p>您在使用点点所提供的产品或服务前，务必仔细阅读本隐私政策，您需在充分理解并同意本隐私政策后，再使用相关产品或服务。您知晓并理解点点将不断优化、迭代或新增为您提供的产品或者服务，点点将据此不时更新本隐私政策，为保障您的个人信息权利，请您及时查阅最新版本的隐私政策。<b>一旦您开始使用点点提供的产品或服务，即表示您已充分理解并同意本隐私政策及更新版。</b></p>

		<p>点点的运营者为：深圳蜂点科技有限公司</p>

		<p>注册地址：深圳市南山区南山街道南海大道西桂庙路北阳光华艺大厦1栋4楼4D16</p>

		<p>本隐私政策的最近更新日期： 2019 年 4 月 1 日</p>

		<p>如您有任何疑问、意见或者建议，请通过以下方式和我们联系：</p>

		<p>电 话：4000666122（工作日9:00-21:00）</p>

		<p>为便于您了解本隐私声明内容，您可以根据以下提纲阅读相应章节</p>

		<p>1.我们如何收集和使用您的个人信息</p>

		<p>2.我们如何使用Cookie和同类技术</p>

		<p>3.我们如何共享、转让、公开披露您的个人信息</p>

		<p>4.我们如何保护您的个人信息</p>

		<p>5.您的权利</p>

		<p>6.我们如何处理儿童的个人信息</p>

		<p>7.您的个人信息不存在全球范围内转移</p>

		<p>8.本政策如何更新</p>

		<p>9.如何联系我们</p>

		<p>点点深知个人信息对您的重要性，并会竭尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺将按照业界成熟的标准，采取相应的安全措施来保护您的个人信息。</p>

		<p><b>一．我们如何收集和使用您的个人信息</b></p>

		<p><b>（一）定义</b></p>

		<p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>

		<p>匿名化：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得信息不属于个人信息。</p>

		<p>去标识化：通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</p>

		<p><b>（二）点点会出于本政策所述的以下目的，收集和使用您的个人信息。</b></p>

		<p><b>1.注册成为点点用户</b></p>

		<p>您注册成为点点用户，是使用点点为您提供服务或产品的前提，若您不注册成为点点用户，将无法登陆点点页面，并浏览或查看点点产品或服务。</p>

		<p>为完成账号创建，您需提供以下信息：<b>手机号</b>、<b>短信验证码</b>、<b>创建的登录密码。</b></p>

		<p>您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</p>

		<p><b>2.为您提供网上购物服务</b></p>

		<p>您使用点点进行网上购物服务时，需提供您的订单信息（如收件人姓名、手机号、地址信息等）、产品信息（如名称、型号、规格、价款等）、银行卡号等支付账户信息。</p>

		<p>您提供的上述信息将用来为您提供产品推荐、下单、完成支付、配送、售后、订单信息查询等服务。</p>

		<p>您提供的上述信息，将在您使用本网上购物服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</p>

		<p>若您在网上购物时，选择分期付款服务，点点将协助第三方为您提供分期服务，您明确知晓，你需按照操作页面指引，在“支付宝-花呗”的第三方页面完成分期服务申请。您在第三方操作页面的任何信息，除非获得您的书面授权，点点不会访问、收集、留存或做任何形式的信息处理。</p>

		<p><b>3.为您提供消费金融咨询服务</b></p>

		<p>您使用点点上的消费金融服务时，如贷款业务、点点闪付服务等，需提供下列信息：</p>

		<p>3.1 您在办理贷款业务时，需提供您的个人基本信息，如姓名、<b>手机号、身份证号</b>、住址、学历、手机定位信息、手机通讯录信息，并需提供<b>身份证件影印件</b>、<b>银行卡号</b>进行实名认证<b>，</b>并按照要求进行<b>人脸识别</b>进行身份验证。</p>

		<p>您明确知晓，上述信息将用于贷款方/出借方及担保方、保险人及咨询服务方等贷款业务直接相关方或受托方，对您进行风险审核之用（如判断该申请行为是否为您本人操作、您的信用状况评级等）以及在业务存续期间持续的为您提供贷后、保后、支付、查账还款等管理服务。</p>

		<p>您明确知晓您的姓名、<b>手机号、身份证号、银行卡号、</b>工作单位等信息将可能被以加密方式提供给金融信息基础数据库、经批准合法成立的综合信息用服务机构、企业征信机构等合法成立的大数据服务机构用来收集相关机构合法储存并有权提供的您的相关信用信息或评价结果。</p>

		<p>您提供的上述信息，将在您使用本金融咨询服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</p>

		<p>3.2 您在使用点点的闪付服务时，需提供您的<b>姓名、身份证号、银行卡号和该卡对应的银行预留手机号</b>。您明确知晓，上述信息将用于闪付服务申请时的实名认证和风险审核之用以及服务期间持续为您提供线下支付、线上查账等服务。</p>

		<p>您提供的上述信息，将用于闪付服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</p>

		<p><b>4.生活娱乐服务</b></p>

		<p>为使用点点的生活娱乐服务，如小游戏、通过完成点点任务赚取奖励金、积分、需提供您的<b>手机号、身份证号信息</b>用于实名认证和积分获取和消费。</p>

		<p>您提供的上述信息，将在您使用本生活娱乐服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</p>

		<p><b>5、第三方服务</b></p>

		<p>点点为您展示合作的第三方提供的服务或产品，如信用卡办理、保险产品、充值缴费等。您明确知晓点点仅为该产品最终提供方的技术服务提供方，您的申请行为将通过在该第三方页面完成，您在该页面提供的信息，依据您和第三方的约定进行。</p>

		<p>若我们要将信息用于本政策未载明的其他用途时，会事先征求您的授权。</p>

		<p>当我们要将基于特定目的收集的信息用于其他目的时，会事先征求您的同意。</p>

		<p><b>6、个性化推荐</b></p>

		<p>点点可能会对使用您的用户画像，为您提供个性化推荐服务，即点点页面上为您展示符合您画像的产品或服务信息。点点承诺不会将您的画像用于其他用途。</p>

		<p><b>二、我们如何使用使用Cookie或同类技术</b></p>

		<p>为使您获得更为轻松的访问体验，您访问点点官网、移动应用程序或使用点点提供的产品或服务，点点可能会通过采用各种自动数据收集工具对您的相关信息进行收集、保存、使用等方式处理，包括但不限于您的网络信息、设备标识符、硬件型号、操作系统版本、您的位置、软件使用习惯、以及与点点的服务相关的日志信息、浏览记录等。自动数据收集服务是为了识别您的身份、解您的使用习惯，帮您省去重复输入注册信息的步骤，帮助判断您的帐户安全等。这些数据可能是Cookie、Flash
			Cookie，或您的浏览器或关联应用程序提供的其他本地存储。</p>

		<p><b>（一）Cookie</b></p>

		<p>请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝点点的Cookie。多数浏览器工具条中的“帮助”部分会告诉您怎样防止您的浏览器接受新的Cookie，怎样让您的浏览器在您收到一条新Cookie时通知您或者怎样彻底关闭Cookie。此外，您可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的Flash
			Cookie及类似数据。但这一举动在某些情况下可能会影响您安全访问和使用点点提供的服务。</p>

		<p><b>（二）限制自动采集信息工具的方法：</b></p>

		<p>安卓手机：进入设置-应用程序管理，选择点点app，储存-删除数据，即可清空缓存信息。</p>

		<p>苹果手机：进入设置，选择应用管理，选择点点app，删除应用后重装，即可清空缓存信息。</p>

		<p><b>三、我们如何共享、转让、公开披露您的个人信息</b></p>

		<p>（一）共享</p>

		<p>点点不会与任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>

		<p>1、在获取明确同意的情况下共享：获得您的明确同意后，点点会与其他方共享您的个人信息；</p>

		<p>2、在法定情形下的共享：点点可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息；</p>

		<p>3、与授权合作伙伴共享：<b>仅为实现本隐私政策中约定的目的，点点在某些必要情形下可能与合作伙伴共享您的个人信息。</b>例如，某些服务和（或）产品由我们的合作伙伴提供或由我们与合作伙伴、供应商共同提供或委托第三方提供。点点仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。<b>点点的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。</b></p>

		<p>对点点与之共享个人信息的公司、组织和个人，点点会与其签署严格的数据保护协定，要求他们按照点点的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>

		<p>（二）转让</p>

		<p>点点不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外:</p>

		<p>1、在获取明确同意的情况下转让：获得您的明确同意后，点点方可向其他方转让您的个人信息；</p>

		<p>2、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，点点会要求新的持有您个人信息的公司、组织继续受本隐私声明的约束，否则,点点将要求该公司、组织重新向您征求授权同意。 </p>

		<p>（三）公开披露</p>

		<p>点点仅会在以下情况下，公开披露您的个人信息：</p>

		<p>1、在获取您明确同意或基于您的主动选择，点点可能会公开披露您的个人信息；</p>

		<p>2、应政府部门、监管机构或司法机关依据法律法规或监管规定的要求而披露。</p>

		<p>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>

		<p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>

		<p>1、与国家安全、国防安全有关的；</p>

		<p>2、与公共安全、公共卫生、重大公共利益有关的；</p>

		<p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>

		<p>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

		<p>5、您自行向社会公众公开的个人信息；</p>

		<p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

		<p>根据法律法规规定，共享、转让、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>

		<p><b>四、我们如何保护您的个人信息</b></p>

		<p>1、我们已使用符合业界标准的安全防护措施保护您提供的个人信息， 防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据(如信用卡信息)时受 SSL 加密保护;我们同时对点点的app和网页提供
			https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息;以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。 </p>

		<p>2、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>

		<p>3、互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他点点用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>

		<p>4、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>

		<p>5、在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取 的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>

		<p>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>

		<p><b>五、您的权利</b></p>

		<p>按照中国相关的法律、法规、标准，我们保障您对自己个人信息行使以下权利：</p>

		<p><b>（一）访问您的个人信息</b></p>

		<p>您有权访问您的个人信息，法律法规规定的例外情形除外。如果你想行使数据访问权，可以通过以下方式访问：</p>

		<p>您可以提交书面请求以查阅您的个人信息。</p>

		<p><b>（二）更正您的个人信息</b></p>

		<p>当您发现我们处理您的个人信息错误或者有任何变动时，您有权要求书面通知我们，要我们更正或者更新。您可以通过以下方式提出更正申请。</p>

		<p>方式：联系客服电话，提交书面请求。</p>

		<p>我们将在15天内回复您的更正请求。</p>

		<p><b>（三）删除您的个人信息</b></p>

		<p>以下情形，您可以向我们提出删除个人信息的请求：</p>

		<p>1.如果我们处理个人信息的行为违反法律法规</p>

		<p>2.如果我们收集、使用您的个人信息，却未征得您的同意</p>

		<p>3.如果我们处理个人信息的行为违反了和您的约定</p>

		<p>4.如果您不再使用我们的产品或服务，并注销了账号</p>

		<p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除。除非法律法规另有规定，或者这些实体取得您的独立授权。</p>

		<p>当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应信息，但会在备份更新时删除这些信息。</p>

		<p><b>（四）改变您授权同意的范围</b></p>

		<p>4.1每个业务功能需要一些基本的个人信息才得以完成（见本政策“第一部分”）。除非另有约定，对于额外收集的个人信息的收集和使用，您可以随时给予或者收回您的授权同意。</p>

		<p>4.2 如果您不想接受我们给您发送的商业广告，您随时可以通过手机系统设置关闭APP推送权限进行取消。</p>

		<p><b>（五）个人信息主体注销账户</b></p>

		<p>您在符合本隐私政策规定的相关条件时，可以注销您的账户，您可以通过如下方式进行操作：联系客服进行注销账户申请，一般情况下，我们会在15日内进行回复。</p>

		<p>在账户注销之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定除外。</p>

		<p><b>您理解并知晓，您注销账户前需保证您在点点上购买的商品、享受的服务等已终止，且不存在对点点或交易相对方应承担的违约或侵权责任。</b></p>

		<p><b>（六）个人信息主体获取个人信息副本</b></p>

		<p>您有权获得您的个人信息副本，您可以通过在点点相关页面的相应功能模块中查找因该业务功能所产生的个人信息副本。</p>

		<p><b>（七）约束信息系统自动决策</b></p>

		<p>在某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</p>

		<p><b>（八）响应您的上述请求</b></p>

		<p>为保障安全，点点可能会先要求您验证自己的身份，然后再处理您的请求。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，点点可能会予以拒绝。</p>

		<p>在以下情形中，按照法律法规要求，点点将无法响应您的请求：</p>

		<p>（1）与国家安全、国防安全有关的；</p>

		<p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>

		<p>（3）与犯罪侦查、起诉、审判和执行判决等有关的；</p>

		<p>（4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>

		<p>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>

		<p>（6）涉及商业秘密的。</p>

		<p><b>五、我们如何处理儿童的个人信息</b></p>

		<p>我们的产品、网站和服务主要面对成年人。如果没有父母或者监护人的同意，儿童不得创建自己的用户账户。</p>

		<p>对于经父母同意而收集儿童个人信息的情况，我们只会在收到法律允许、父母或及监护人明确同意或者保护儿童所必要的情况下，使用和公开披露此信息。</p>

		<p>尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。</p>

		<p>如果我们发现自己在未事先获得可证实的父母的同意的情况下收集了儿童的个人信息，则会设法删除相关数据。</p>

		<p><b>六、您的个人信息不在全球范围内转移</b></p>

		<p>我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内，不会在全球范围内转移。</p>

		<p><b>七、本隐私政策如何更新</b></p>

		<p>点点"隐私政策"体现了我们将按照国家关于个人信息保护有关法律法规保护和管理您个人信息的承诺，为给您提供更好的服务，我们会根据不时修订的相关法规要求更新本"隐私政策"。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。</p>

		<p>对于重大变化，我们还会提供更为显著的通知，通知方式包括弹窗、通知、推送通知、邮件、短信等任何一种或多种。</p>

		<p>本政策所指的重大变更包括但不限于：</p>

		<p>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理个人信息的类型、个人信息的使用方式等。</p>

		<p>2.我们在股权结构、组织架构等方面发生的重大变化。如业务调整、破产并购等引起所有者变更。</p>

		<p>3.个人信息的共享、转让、公开披露的主要对象发生变化。</p>

		<p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化</p>

		<p>5.我们负责处理信息安全的责任部门、联络方式和投诉渠道发生变化时</p>

		<p>6.个人信息安全影响评估报告表明存在高风险时。</p>

		<p>我们的"隐私政策"公布于点点官方网站及移动端，方便您随时查阅，及时了解点点最新的隐私政策。</p>

		<p><b>八、如何联系我们</b></p>

		<p>如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，任何与您个人信息有关的请求或投诉，以及要求取消您所选取的点点的任何服务，请通过以下方式与我们联系：</p>

		<p>微信公众号“点点官微”或4000666122（工作日9:00-21:00）</p>

		<p>一般情况下，我们将在15天内进行回复。</p>

		<p>如您对我们的回复不满意，特别是我们的个人信息处理侵犯您的合法权益，您可以通过法院、行业自律机构、行政监管部门寻求外部救济。</p>





	</div>
	<div v-if="isAuditing">
		<h2 class="fwbd tc mt20">隐私政策</h2>
		<div data-header="3">
			<p><strong class="fwbd">隐私政策&nbsp;</strong></p>
			<p>&nbsp;</p>
			<p>点点Go（本平台）尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本平台会按照本隐私权政策的规定使用和披露您的个人信息。但本平台将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本平台不会将这些信息对外披露或向第三方提供。本平台会不时更新本隐私权政策。 您在同意本平台服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本平台服务使用协议不可分割的一部分。&nbsp;</p>
			<p>&nbsp;</p>
			<ol>
				<li><strong class="fwbd">适用范围</strong></li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>a) 在您注册本平台帐号时，您根据本平台要求提供的个人注册信息；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>b) 在您使用本平台网络服务，或访问本平台平台网页时，本平台自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>c) 本平台通过合法途径从商业伙伴处取得的用户个人数据。</li>
			</ol>
			<p>&nbsp;</p>
			<p>您了解并同意，以下信息不适用本隐私权政策：&nbsp;</p>
			<p>&nbsp;</p>
			<ol>
				<li>a) 您在使用本平台平台提供的搜索服务时输入的关键字信息；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>b) 本平台收集到的您在本平台发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>c) 违反法律规定或违反本平台规则行为及本平台已对您采取的措施。</li>
			</ol>
			<p>&nbsp;</p>
			<ol start="2">
				<li class="fwbd">信息使用</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>a) 本平台不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本平台（含本平台关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>b) 本平台亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本平台平台用户如从事上述活动，一经发现，本平台有权立即终止与该用户的服务协议。</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>c) 为服务用户的目的，本平台可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与本平台合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。</li>
			</ol>
			<p>&nbsp;</p>
			<ol start="3">
				<li><strong class="fwbd">信息披露</strong></li>
			</ol>
			<p>&nbsp;</p>
			<p>在如下情况下，本平台将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：&nbsp;</p>
			<p>&nbsp;</p>
			<ol>
				<li>a) 经您事先同意，向第三方披露；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>d) 如您出现违反中国有关法律、法规或者本平台服务协议或相关规则的情况，需要向第三方披露；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>f) 在本平台平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本平台有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>g) 其它本平台根据法律、法规或者网站政策认为合适的披露。</li>
			</ol>
			<p>&nbsp;</p>
			<ol start="4">
				<li><strong class="fwbd">信息存储和交换</strong></li>
			</ol>
			<p>&nbsp;</p>
			<p>本平台收集的有关您的信息和资料将保存在本平台及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本平台收集信息和资料所在地的境外并在境外被访问、存储和展示。&nbsp;</p>
			<p>&nbsp;</p>
			<ol start="5">
				<li><strong> Cookie</strong><strong>的使用</strong></li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>a) 在您未拒绝接受cookies的情况下，本平台会在您的计算机上设定或取用cookies</li>
			</ol>
			<p>&nbsp;</p>
			<p>，以便您能登录或使用依赖于cookies的本平台平台服务或功能。本平台使用cookies可为您提供更加周到的个性化服务，包括推广服务。&nbsp; b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本平台网络服务或功能。&nbsp;</p>
			<p>&nbsp;</p>
			<ol>
				<li>c) 通过本平台所设cookies所取得的有关信息，将适用本政策。</li>
			</ol>
			<p>&nbsp;</p>
			<ol start="6">
				<li><strong class="fwbd">信息安全</strong></li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>a) 本平台帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本平台将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在&ldquo;完善的安全措施&rdquo;。</li>
			</ol>
			<p>&nbsp;</p>
			<ol>
				<li>b) 在使用本平台网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本平台用户名及密码发生泄露，请您立即联络本平台客服，以便本平台采取相应措施。</li>
			</ol>
		</div>
	</div>
</article>
</template>

<script>
export default {
	data() {
		return {
			isAuditing: false
		}
	},
	beforeRouteEnter(to, from, next) {
		next()
	},
	created() {
		if (this.$route.query.x == 'pointpoint') {
			document.title = '隐私政策'
			this.isAuditing = true
		} else {
			document.title = '点点隐私政策'
			this.isAuditing = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// privacy.vue?77378cf1